import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _en = {
    description: "Select the days you want, then add the exception by clicking on the + button below to assign the new working hours.",
    weekSlotDescription: "Select the days you wish to work and allocate your working hours to them"
};

export type I18nException = typeof _en;

const _fr: I18nException = {
    description: "Séléctionnez votre date de début et de fin puis ajoutez l'exception en cliquant sur le bouton + ci-dessous pour attribuer les nouvelles horaires de travail",
    weekSlotDescription: "Sélectionnez les journées souhaitées afin de leur attribuer vos horaires de travail"
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18n(lang?: string): I18nException {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}